/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormSummaryLink } from './form-summary-link';


export interface PracticeFormSummary { 
    formId?: number;
    formName?: string;
    active?: boolean;
    status?: PracticeFormSummary.StatusEnum;
    updatedTs?: string;
    practiceDefault?: boolean;
    assignedLocationCount?: number;
    links?: Array<FormSummaryLink>;
}
export namespace PracticeFormSummary {
    export const StatusEnum = {
        Active: 'ACTIVE',
        Inactive: 'INACTIVE',
        Incomplete: 'INCOMPLETE'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


